export const notifTypes = [
    {
        id: 'auth',
        value:'Authentication',

    },
    {
        id: 'user',
        value:'User',

    },
    {
        id: 'orders',
        value:'Orders',

    },
    {
        id: 'shipment',
        value:'Shipment',

    },
    {
        id: 'reward',
        value:'Reward',

    },
    {
        id: 'orderStatusUpdate',
        value:'Order Status',

    },
    {
        id: 'caseStudy',
        value:'Case Study',

    },
    {
        id: 'companyRequest',
        value:'Company Request',

    },
    {
        id: 'bespokeForm',
        value:'Bespoke Form',

    },
    {
        id: 'rewardPoints',
        value:'Reward Points',

    },
]